export const money = (v, currency = "USD", digits = 2) => {
  const sym = { USD: "$", EUR: "€", GBP: "£" }[currency] || "";
  const sign = v < 0 ? "−" : v > 0 ? "+" : "";
  return `${sign}${sym}${Math.abs(v).toFixed(digits)}`;
};

export const timeAgo = (iso, now = new Date("2026-06-12T12:00:00Z")) => {
  if (!iso) return "—";
  const diff = (now - new Date(iso)) / 1000;
  if (diff < 3600) return `${Math.max(1, Math.round(diff / 60))}m ago`;
  if (diff < 86400) return `${Math.round(diff / 3600)}h ago`;
  return `${Math.round(diff / 86400)}d ago`;
};

export const fmtDate = (iso, opts = {}) =>
  new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "UTC", ...opts }) + " UTC";

export const fmtPrice = (v) => (v >= 1000 ? v.toLocaleString("en-US", { maximumFractionDigits: 0 }) : v >= 100 ? v.toFixed(2) : v.toFixed(4));
